// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"31d6cfe0","150":"de1de81f","239":"31d6cfe0","560":"dc5e22fa","968":"b3f2f6c0"}[chunkId] + ".chunk.css";
};